import { isDev } from '@/utils/common';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Basis: AppRouteRecordRaw = {
  path: '/basis',
  name: 'Basis',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '基础设置',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 7,
  },
  children: [
    // {
    //   path: 'sys-config',
    //   name: 'SysConfig',
    //   component: () => import('@/views/basis/sysConfig/app.vue'),
    //   meta: {
    //     title: '系统配置',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: '/temporary-template',
      name: 'TemporaryTemplate',
      component: () => import('@/views/temporaryTemplate/index.vue'),
      meta: {
        title: '开发中',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    // {
    //   path: 'index',
    //   name: 'brandMang',
    //   component: () => import('@/views/basis/sysConfig/brandMang.vue'),
    //   meta: {
    //     title: '品牌管理',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'technique',
      name: 'Technique',
      component: () => import('@/views/basis/sysConfig/technique.vue'),
      meta: {
        title: '工艺要求',
        requiresAuth: true,
        roles: ['techniqueGet'],
        hideInMenu: true,
        menuIcon: 'icon-gongyiyaoqiu',
      },
    },
    {
      path: 'part',
      name: 'Part',
      component: () => import('@/views/basis/sysConfig/part.vue'),
      meta: {
        title: '尺寸指示',
        requiresAuth: true,
        roles: ['partGet'],
        hideInMenu: true,
        menuIcon: 'icon-chicunzhishi',
      },
    },
    // {
    //   path: 'style',
    //   name: 'OldGoodsStyle',
    //   component: () => import('@/views/basis/sysConfig/style.vue'),
    //   meta: {
    //     title: '旧版-款式风格管理',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'goods-style',
      name: 'GoodsStyle',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '款式管理',
        requiresAuth: true,
        roles: ['*'],
        amisAppId: isDev() ? '9b5003ce' : 'c613d0f4',
        hideInMenu: true,
        menuIcon: 'icon-kuanshiguanli',
      },
    },
    {
      path: 'color-manage',
      name: 'ColorManage',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '颜色管理',
        requiresAuth: true,
        roles: ['colorGet'],
        amisAppId: isDev() ? '2f4b5ce5' : 'd5a93050',
        hideInMenu: true,
        menuIcon: 'icon-yanseguanli',
      },
    },
    {
      path: 'size-manage',
      name: 'SizeManage',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '尺码管理',
        requiresAuth: true,
        roles: ['sizeGet'],
        amisAppId: isDev() ? '643f7297' : 'e045cc46',
        hideInMenu: true,
        menuIcon: 'icon-chimaguanli',
      },
    },
    {
      path: 'design-order-serial',
      name: 'DesignOrderSerial',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '版次管理',
        requiresAuth: true,
        roles: ['editionGet'],
        amisAppId: isDev() ? 'c5fcd83d' : '1ea44fd6',
        hideInMenu: true,
        menuIcon: 'icon-banciguanli',
      },
    },
    {
      path: 'property',
      name: 'Property',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料规格',
        requiresAuth: true,
        roles: ['materialPropertyGet'],
        amisAppId: isDev() ? '54520b92' : 'e8bed282',
        hideInMenu: true,
        menuIcon: 'icon-wuliaoguige',
      },
    },
    {
      path: 'material-type',
      name: 'MaterialType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料类型',
        requiresAuth: true,
        roles: ['materialTypeGet'],
        // amisAppId: isDev() ? 'ddcc644b' : 'e3711f89',
        amisAppId: isDev() ? 'ddcc644b' : 'd9496dd1', // d9496dd1为按匹实例
        hideInMenu: true,
        menuIcon: 'icon-wuliaoleixing',
      },
    },
    {
      path: 'material-category',
      name: 'MaterialCategory',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料分类',
        requiresAuth: true,
        roles: ['materialCategoryGet'],
        amisAppId: isDev() ? 'ea559ad5' : 'f9db3f13',
        hideInMenu: true,
        menuIcon: 'icon-wuliaofenlei',
      },
    },
    {
      path: 'goods-category',
      name: 'GoodsCategory',
      component: () => import('@/views/basis/goodsCategory/index.vue'),
      meta: {
        title: '商品分类',
        requiresAuth: true,
        roles: ['categoryGet'],
        hideInMenu: true,
        menuIcon: 'icon-shangpinfenlei',
      },
    },
    {
      path: 'washing-method',
      name: 'WashingMethod',
      component: () => import('@/views/basis/washingMethod/index.vue'),
      meta: {
        title: '洗涤方式',
        requiresAuth: true,
        roles: ['washingMethodGet'],
        hideInMenu: true,
        menuIcon: 'icon-xidifangshi',
      },
    },
    {
      path: 'execute-standard',
      name: 'ExecuteStandard',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '执行标准',
        requiresAuth: true,
        roles: ['executeStandardGet'],
        amisAppId: isDev() ? '31382bcb' : '36e60c23',
        hideInMenu: true,
        menuIcon: 'icon-zhihangbiaozhun',
      },
    },
    {
      path: 'security-type',
      name: 'SecurityType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '安全类别',
        requiresAuth: true,
        roles: ['securityTypeGet'],
        amisAppId: isDev() ? '4eeb971c' : '53945e89',
        hideInMenu: true,
        menuIcon: 'icon-anquanleibie',
      },
    },
    // {
    //   path: 'bland',
    //   name: 'Bland',
    //   component: () => import('@/components/QsAmis/index.vue'),
    //   meta: {
    //     title: '品牌管理',
    //     requiresAuth: true,
    //     roles: ['brandGet'],
    //     amisAppId: isDev() ? 'de9561ef' : '0ca8147e',
    //     hideInMenu: true,
    //   },
    // },
    {
      path: 'bland',
      name: 'Bland',
      component: () => import('@/views/basis/bland/index.vue'),
      meta: {
        title: '品牌管理',
        requiresAuth: true,
        roles: ['brandGet'],
        hideInMenu: true,
        menuIcon: 'icon-pinpaiguanli',
      },
    },
    {
      path: 'unit',
      name: 'Unit',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '单位管理',
        requiresAuth: true,
        roles: ['unitGet'],
        amisAppId: isDev() ? 'b7a43441' : '134e3412',
        hideInMenu: true,
        menuIcon: 'icon-danweiguanli',
      },
    },
    {
      path: 'season',
      name: 'Season',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '季节管理',
        requiresAuth: true,
        roles: ['seasonGet'],
        amisAppId: isDev() ? '4ffa32e6' : '5418dccd',
        hideInMenu: true,
        menuIcon: 'icon-jijieguanli',
      },
    },
    {
      path: 'inspectionQuestion',
      name: 'InspectionQuestion',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '质检问题管理',
        requiresAuth: true,
        roles: ['inspectionProblemGet'],
        amisAppId: isDev() ? 'e165fbf0' : 'e7514d3f',
        hideInMenu: true,
        menuIcon: 'icon-zhiliangwentiguanli',
      },
    },
    {
      path: 'print-part',
      name: 'PrintPart',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '部位管理',
        requiresAuth: true,
        roles: ['workTicketPartGet'],
        amisAppId: isDev() ? '5fcd73c4' : 'bb91ab16',
        hideInMenu: true,
        menuIcon: 'icon-buweiguanli',
      },
    },
    {
      path: 'ranges',
      name: 'Ranges',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '波段管理',
        requiresAuth: true,
        roles: ['rangesGet'],
        amisAppId: isDev() ? '98ba78c5' : '18ae44d3',
        hideInMenu: true,
        menuIcon: 'icon-boduanguanli',
      },
    },
    {
      path: 'order-type',
      name: 'OrderType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '订单类型',
        requiresAuth: true,
        roles: ['orderTypeGet'],
        amisAppId: isDev() ? '4bbf9171' : '32a5b99e',
        hideInMenu: true,
        menuIcon: 'icon-dingdanleixing',
      },
    },
    {
      path: 'work-process-group',
      name: 'WorkProcessGroup',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '节点分组管理',
        requiresAuth: true,
        roles: ['workProcessGroupGet'],
        amisAppId: isDev() ? '2b1ffe45' : 'd2154f36',
        hideInMenu: true,
        menuIcon: 'icon-jiedianfenzuguanli',
      },
    },
    {
      path: 'clientItem',
      name: 'ClientItem',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '客户分类',
        requiresAuth: true,
        roles: ['clientItemGet'],
        amisAppId: isDev() ? 'ebf9aa79' : '1eb56deb',
        hideInMenu: true,
        menuIcon: 'icon-kehufenlei',
      },
    },
    {
      path: 'supplierLevel',
      name: 'SupplierLevel',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '供应商等级',
        requiresAuth: true,
        roles: ['supplierLevelGet'],
        amisAppId: isDev() ? 'be5df61e' : '28ddd2f6',
        hideInMenu: true,
        menuIcon: 'icon-gongyingshangdengji',
      },
    },
    {
      path: 'balanceAccount',
      name: 'BalanceAccount',
      component: () => import('@/views/basis/balanceAccount/index.vue'),
      meta: {
        title: '结算账户',
        requiresAuth: true,
        roles: ['accountGet'],
        hideInMenu: true,
        menuIcon: 'icon-jiesuanzhanghu',
      },
    },
    {
      path: 'accountType',
      name: 'AccountType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '账目类型',
        requiresAuth: true,
        roles: ['accountItemGet'],
        amisAppId: isDev() ? 'e0480e21' : '3cb374d2',
        hideInMenu: true,
        menuIcon: 'icon-zhangmuleixing',
      },
    },
    {
      path: 'position',
      name: 'Position',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '职位',
        requiresAuth: true,
        roles: ['positionGet'],
        amisAppId: isDev() ? 'd7216dae' : '4159e7a7',
        hideInMenu: true,
        menuIcon: 'icon-zhiwei',
      },
    },
    {
      path: 'dashboard-manage',
      name: 'DashboardManage',
      component: () => import('@/views/basis/dashboardManage/index.vue'),
      meta: {
        title: '首页权限设定',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['dashboardGet'],
        menuIcon: 'icon-shouyequanxiansheding',
      },
    },
    {
      path: 'storehouse-position',
      name: 'StorehousePosition',
      component: () =>
        import('@/views/basis/storehousePositionManage/index.vue'),
      meta: {
        title: '库位管理',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['storeLocationGet'],
        menuIcon: 'icon-kuweiguanli',
      },
    },
    {
      path: 'supplier-manage',
      name: 'SupplierManage',
      component: () => import('@/views/basis/supplierManage/index.vue'),
      meta: {
        title: '供应商管理',
        requiresAuth: true,
        roles: ['supplierGet', 'supplierInfoGetDataPermission'],
        menuIcon: 'icon-gysgl',
      },
    },
    {
      path: 'supplier-add',
      name: 'SupplierAdd',
      component: async () => {
        const cpn = await import(
          '@/views/basis/supplierManage/addOrEditSupplier.vue'
        );
        return { ...cpn.default, name: 'SupplierAdd' };
      },
      meta: {
        title: '新增供应商',
        requiresAuth: true,
        roles: ['supplierEdit'],
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'supplier-edit',
      name: 'SupplierEdit',
      component: async () => {
        const cpn = await import(
          '@/views/basis/supplierManage/addOrEditSupplier.vue'
        );
        return { ...cpn.default, name: 'SupplierEdit' };
      },
      meta: {
        title: '编辑供应商',
        requiresAuth: true,
        roles: ['supplierGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'client-management',
      name: 'ClientManagement',
      component: () => import('@/views/basis/sysConfig/clientManagement.vue'),
      meta: {
        title: '客户管理',
        requiresAuth: true,
        roles: ['clientGet'],
        menuIcon: 'icon-khgl',
      },
    },
    {
      path: 'store-management',
      name: 'StoreManagement',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '仓库管理',
        requiresAuth: true,
        roles: ['storehouseGet'],
        amisAppId: isDev() ? '74ad579f' : '48091186',
        menuIcon: 'icon-ckgl',
      },
    },
    {
      path: 'print-setting',
      name: 'PrintSetting',
      component: () => import('@/views/basis/sysConfig/printSetting.vue'),
      meta: {
        title: '单据云打印',
        requiresAuth: true,
        roles: ['*'],
        menuIcon: 'icon-danjuyundayin',
      },
    },
    {
      path: 'print-template',
      name: 'PrintTemplate',
      component: () => import('@/views/basis/sysConfig/printTemplate.vue'),
      meta: {
        title: '自定义打印模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        menuIcon: 'icon-zidingyidayinmoban',
      },
    },
    {
      path: 'washing-label-template',
      name: 'WashingLabelTemplate',
      component: () => import('@/views/basis/washingLabelTemplate/index.vue'),
      meta: {
        title: '洗水唛/标签模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        menuIcon: 'icon-xishuimaibiaoqianmoban',
        // iframe: true,
      },
    },
    {
      path: 'production-node-template',
      name: 'ProductionNodeTemplate',
      component: () => import('@/views/basis/productionNodeTemplate/index.vue'),
      meta: {
        title: '工序节点模板',
        requiresAuth: true,
        roles: ['workProcessTemplateGet'],
        hideInMenu: true,
        menuIcon: 'icon-scjdmb',
      },
    },
    {
      path: 'bom-template',
      name: 'BomTemplate',
      component: () => import('@/views/basis/bomTemplate/index.vue'),
      meta: {
        title: 'BOM模板',
        requiresAuth: true,
        roles: ['bomTemplateGet'],
        hideInMenu: true,
        menuIcon: 'icon-BOMmoban',
      },
    },
    {
      path: 'process-fee-template',
      name: 'ProcessFeeTemplate',
      component: () => import('@/views/basis/processFeeTemplate/index.vue'),
      meta: {
        title: '加工费模板',
        requiresAuth: true,
        roles: ['processFeeTemplateGet'],
        hideInMenu: true,
        menuIcon: 'icon-jiagongfeimobanicon',
      },
    },
    {
      path: 'production-order-template',
      name: 'ProductionOrderTemplate',
      component: () =>
        import('@/views/basis/productionOrderTemplate/index.vue'),
      meta: {
        title: '生产制单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        iframe: true,
        menuIcon: 'icon-shengchanzhidanmoban',
      },
    },
    {
      path: 'purchase-order-template',
      name: 'PurchaseOrderTemplate',
      component: () => import('@/views/basis/purchaseOrderTemplate/index.vue'),
      meta: {
        title: '采购单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        iframe: true,
        menuIcon: 'icon-caigoudanmoban',
      },
    },
    {
      path: 'sample-template',
      name: 'SampleTemplate',
      component: () => import('@/views/basis/sampleTemplate/index.vue'),
      meta: {
        title: '商品/设计款模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        iframe: true,
        menuIcon: 'icon-shangpinshejikuanmoban',
      },
    },
    {
      path: 'design-order-template',
      name: 'DesignOrderTemplate',
      component: () => import('@/views/basis/designOrderTemplate.vue'),
      meta: {
        title: '版单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        iframe: true,
        menuIcon: 'icon-bandanmoban',
      },
    },
    {
      path: 'work-process-print-template',
      name: 'WorkProcessPrintTemplate',
      component: () =>
        import('@/views/basis/workProcessPrintTemplate/index.vue'),
      meta: {
        title: '工序打印模板',
        requiresAuth: true,
        roles: ['systemConfigGet'],
        hideInMenu: true,
        menuIcon: 'icon-gongxudayinmoban',
      },
    },
    {
      path: 'staff-management',
      name: 'StaffManagement',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '员工管理',
        requiresAuth: true,
        roles: ['userGet'],
        amisAppId: isDev() ? '99f254bb' : 'a4bcca99',
        hideInMenu: true,
        menuIcon: 'icon-yggl',
      },
    },
    // {
    //   path: 'role-management-amis',
    //   name: 'RoleManagementAmis',
    //   component: () => import('@/components/QsAmis/index.vue'),
    //   meta: {
    //     title: '角色权限amis',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     hideInMenu: !isDev(),
    //     amisAppId: isDev() ? '732a6161' : 'c643bd36',
    //   },
    // },
    {
      path: 'role-management',
      name: 'RoleManagement',
      component: () => import('@/views/basis/role/index.vue'),
      meta: {
        title: '角色权限',
        requiresAuth: true,
        roles: ['roleGet'],
        hideInMenu: true,
        menuIcon: 'icon-jsqx',
      },
    },
    {
      path: 'department',
      name: 'Department',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '组织架构',
        requiresAuth: true,
        roles: ['departmentGet'],
        amisAppId: isDev() ? '2a6163a3' : '54cdc377',
        hideInMenu: true,
        menuIcon: 'icon-zzjg',
      },
    },
    {
      path: 'log-query',
      name: 'LogQuery',
      component: () => import('@/views/basis/logQuery/index.vue'),
      meta: {
        title: '日志查询',
        requiresAuth: true,
        roles: ['operateLog'],
        hideInMenu: true,
        menuIcon: 'icon-rizhichaxun',
      },
    },
    {
      path: 'log-query-from-local',
      name: 'LogQueryFromLocal',
      component: () => import('@/views/basis/logQuery/local.vue'),
      props: (route: any) => {
        return {
          pageSource: route.query.pageSource,
          searchParams: route.query.searchParams,
          tag: route.query.tag,
        };
      },
      meta: {
        title: '日志查询',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        menuIcon: 'icon-rizhichaxun',
      },
    },
    {
      path: 'todo-rules',
      name: 'TodoRules',
      component: () => import('@/views/basis/todoRules/index.vue'),
      meta: {
        title: '待办任务规则',
        requiresAuth: true,
        roles: ['todoConfigGet'],
        hideInMenu: true,
        menuIcon: 'icon-daibanrenwuguize1',
      },
    },
    {
      path: 'system-log',
      name: 'SystemLog',
      component: () => import('@/views/basis/systemLog/index.vue'),
      meta: {
        title: '系统日志',
        requiresAuth: true,
        roles: [],
        hideInMenu: true,
        menuIcon: 'icon-rizhichaxun',
      },
    },
    {
      path: 'auditConfig',
      name: 'AuditConfig',
      component: () => import('@/views/basis/auditConfig/index.vue'),
      meta: {
        title: '审批配置',
        requiresAuth: true,
        roles: ['auditConfigGet'],
        hideInMenu: true,
        menuIcon: 'icon-shenpipeizhi',
      },
    },
    {
      path: 'thirdparty',
      name: 'Thirdparty',
      component: () => import('@/views/basis/thirdparty/index.vue'),
      props: (route: any) => {
        return {
          from: route.query.from,
          thirdPartSourceKey: route.query.thirdPartSourceKey,
        };
      },
      meta: {
        title: '第三方对接',
        requiresAuth: true,
        roles: ['thirdpartGet'],
        hideInMenu: true,
        menuIcon: 'icon-disanfangduijie',
      },
    },
    {
      path: 'thirdpartySyncLog',
      name: 'ThirdpartySyncLog',
      component: () => import('@/views/basis/thirdparty/ThirdpartySyncLog.vue'),
      meta: {
        title: '同步日志',
        requiresAuth: true,
        roles: ['thirdpartGet'],
        hideInMenu: true,
      },
    },
    {
      // 开放平台
      path: 'openPlatform',
      name: 'OpenPlatform',
      component: () => import('@/views/basis/open-platform/index.vue'),
      props: (route: any) => {
        return {
          from: route.query.from,
        };
      },
      meta: {
        title: '开放平台',
        requiresAuth: true,
        hideInMenu: false,
        roles: ['oauthGet'],
        menuIcon: 'icon-kaifangpingtai',
      },
    },
    {
      // 开放平台测试
      path: 'authApp',
      name: 'AuthApp',
      component: () => import('@/views/basis/open-platform/AuthApp.vue'),
      props: (route: any) => {
        return {
          from: route.query.from,
        };
      },
      meta: {
        title: '开放平台申请',
        requiresAuth: false,
        hideInMenu: true,
      },
    },
    {
      // API测试工具
      path: 'tools',
      name: 'Tools',
      component: () => import('@/views/basis/open-platform/tools.vue'),
      props: (route: any) => {
        return {
          from: route.query.from,
        };
      },
      meta: {
        title: 'API测试',
        requiresAuth: false,
        hideInMenu: true,
      },
    },
    {
      path: 'clothing-node-template',
      name: 'ClothingNodeTemplate',
      component: () => import('@/views/basis/clothingNodeTemplate/index.vue'),
      meta: {
        title: '样衣节点模板',
        requiresAuth: true,
        roles: ['designNodeGet'],
        hideInMenu: true,
        menuIcon: 'icon-yangyijiedianmoban',
      },
    },
    {
      path: 'size-model',
      name: 'SizeModel',
      component: () => import('@/views/basis/sizeModel/index.vue'),
      meta: {
        title: '服装号型',
        requiresAuth: true,
        roles: ['sizeModelGet'],
        hideInMenu: true,
        menuIcon: 'icon-fuzhuangxinghao',
      },
    },
    {
      path: 'image-label',
      name: 'ImageLabel',
      component: () => import('@/views/basis/imageLabel/index.vue'),
      meta: {
        title: '图片标签管理',
        requiresAuth: true,
        roles: ['imgTagGet'],
        hideInMenu: true,
        menuIcon: 'icon-tupianbiaoqianguanli',
      },
    },
    {
      path: 'custom-base-info',
      name: 'CustomBaseInfo',
      component: () => import('@/views/basis/customBaseInfo/index.vue'),
      meta: {
        title: '基础信息管理',
        requiresAuth: true,
        roles: ['attributeGet'],
        hideInMenu: true,
        menuIcon: 'icon-jichuxinxiguanli',
      },
    },
    {
      path: 'index',
      name: 'sysConfigIndex',
      component: () => import('@/views/basis/sysConfig/index.vue'),
      meta: {
        title: '系统配置',
        requiresAuth: true,
        roles: ['*'],
        menuIcon: 'icon-xtpz',
      },
    },
    {
      path: 'sys-control',
      name: 'SystemControl',
      component: () => import('@/views/basis/sysConfig/control.vue'),
      meta: {
        title: '系统控制',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['systemConfigGet'],
        menuIcon: 'icon-xitongkongzhi',
      },
    },
    {
      path: 'version-info',
      name: 'VersionInfo',
      component: () => import('@/views/basis/sysConfig/version.vue'),
      meta: {
        title: '版本信息',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['*'],
        menuIcon: 'icon-banbenxinxi',
      },
    },
    {
      path: 'workday-setting',
      name: 'WorkdaySetting',
      component: () => import('@/views/basis/workdaySetting/index.vue'),
      meta: {
        title: '工作日设置',
        requiresAuth: true,
        roles: ['restDateGet'],
        hideInMenu: true,
        menuIcon: 'icon-gongzuorishezhi',
      },
    },
  ],
};

export default Basis;
